(function () {
  if (window.__bomeBulkCartReady) return;
  window.__bomeBulkCartReady = true;
  const pending = new WeakSet();

  function message(root, text) {
    const node = root.querySelector("[data-bome-bulk-error], [data-diagnostic-program-error]");
    if (!node) return;
    node.textContent = text || "";
    node.hidden = !text;
  }

  function itemsFor(root) {
    const program = root.matches("diagnostic-program-cart");
    const selector = program
      ? "[data-diagnostic-program-items] [data-variant-id]"
      : "[data-button-add-to-cart-items] [data-variant-id]";
    const items = new Map();
    root.querySelectorAll(selector).forEach(function (node) {
      const id = Number(node.dataset.variantId);
      const quantity = Math.floor(Number(node.dataset.qty || 1));
      if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(quantity) || quantity <= 0) return;
      if (program && items.has(id)) return;
      items.set(id, (items.get(id) || 0) + quantity);
    });
    return Array.from(items, function (entry) {
      return { id: entry[0], quantity: entry[1] };
    });
  }

  function cartUrl(root) {
    return root.dataset.cartUrl || (window.routes && window.routes.cart_url) ||
      ((window.Shopify && window.Shopify.routes.root) || "/") + "cart";
  }

  function addUrl(root) {
    return root.dataset.cartAddUrl || (window.routes && window.routes.cart_add_url) ||
      ((window.Shopify && window.Shopify.routes.root) || "/") + "cart/add.js";
  }

  function usableSections(response, sections) {
    return response && response.sections && sections.every(function (section) {
      return typeof response.sections[section.id] === "string" && response.sections[section.id].trim() !== "";
    });
  }

  async function renderCart(root, response, button, cart, sections) {
    const onCartPage = document.body.classList.contains("template-cart");
    if (!cart || cart.dataset.cartType !== "drawer" || onCartPage ||
        typeof cart.renderContents !== "function" || typeof cart.toggleDrawerClasses !== "function") {
      window.location.assign(cartUrl(root));
      return;
    }

    if (!usableSections(response, sections)) {
      const url = new URL((window.Shopify && window.Shopify.routes.root) || "/", window.location.origin);
      url.searchParams.set("sections", sections.map(function (section) { return section.id; }).join(","));
      const rendered = await fetch(url.toString(), { headers: { Accept: "application/json" } });
      if (!rendered.ok) throw new Error("Cart sections unavailable");
      response = { sections: await rendered.json() };
    }
    if (!usableSections(response, sections)) throw new Error("Cart sections unavailable");

    if (typeof cart.setActiveElement === "function") cart.setActiveElement(button);
    if (typeof cart.rememberOpener === "function") cart.rememberOpener({ currentTarget: button });
    cart.renderContents(response, false);
    cart.classList.remove("is-empty");
    if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: "bome-bulk-cart", cartData: response });
    }
    if (!cart.isOpen) cart.toggleDrawerClasses();
  }

  // Handle the click before a wrapping Wonder js-link can navigate away.
  document.addEventListener("click", async function (event) {
    const button = event.target && typeof event.target.closest === "function"
      ? event.target.closest("[data-button-add-to-cart-trigger], [data-diagnostic-program-trigger]")
      : null;
    if (!button) return;
    const root = button.closest("[data-button-add-to-cart], diagnostic-program-cart");
    if (!root) return;
    event.preventDefault();
    event.stopPropagation();
    if (button.disabled || pending.has(root)) return;

    const items = itemsFor(root);
    if (!items.length) {
      message(root, root.dataset.bomeBulkEmpty);
      return;
    }

    const cart = document.querySelector("cart-drawer");
    const sections = cart && typeof cart.getSectionsToRender === "function"
      ? cart.getSectionsToRender().slice(0, 5)
      : [];
    pending.add(root);
    button.disabled = true;
    button.setAttribute("aria-busy", "true");
    message(root, "");
    let response;
    let added = 0;

    try {
      for (let index = 0; index < items.length; index += 20) {
        const batch = items.slice(index, index + 20);
        const data = { items: batch };
        if (index + 20 >= items.length && sections.length) {
          data.sections = sections.map(function (section) { return section.id; });
          data.sections_url = window.location.pathname;
        }
        const result = await fetch(addUrl(root), {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify(data)
        });
        response = await result.json();
        if (!result.ok || (response.status && Number(response.status) >= 400)) {
          const detail = typeof response.description === "string" ? response.description : root.dataset.bomeBulkError;
          throw new Error(detail || root.dataset.bomeBulkError);
        }
        added += batch.length;
      }
    } catch (error) {
      message(root, added ? root.dataset.bomeBulkPartial : error.message || root.dataset.bomeBulkError);
      if (added) document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
      pending.delete(root);
      button.disabled = false;
      button.removeAttribute("aria-busy");
      return;
    }

    try {
      await renderCart(root, response, button, cart, sections);
    } catch (error) {
      window.location.assign(cartUrl(root));
    } finally {
      pending.delete(root);
      button.disabled = false;
      button.removeAttribute("aria-busy");
    }
  }, { capture: true });
})();

